import Route from '@ember/routing/route';
import RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class PslfEmployerRoute extends Route {
  @service declare router: RouterService;

  queryParams = {
    approval: { refreshModel: true, replace: true },
  };

  model(params: { form_document_id: string }) {
    const { form_document_id } = params;
    return {
      documentId: form_document_id,
    };
  }

  afterModel(model: { documentId: string }) {
    // V2 forms document ids start with 'template:'
    // once we are off of sign now we can direct everything to non-partner-sign and remove non-partner-verification
    if (model.documentId.startsWith('template')) {
      this.router.transitionTo('pslf-employer.non-partner-sign');
    } else {
      this.router.transitionTo('pslf-employer.non-partner-verification');
    }
  }
}
